import axios from "axios";
import { BaseUrl } from "../Routes/BaseUrl";

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

export const findUserByMobile = async (identifier) => {
  let url = "";

  if (typeof identifier === "string") {
    url = `${BaseUrl.trim()}/admin/find-user?mobileNumber=${identifier}`;
  } else {
    const { mobileNumber, email } = identifier || {};
    if (email) {
      url = `${BaseUrl.trim()}/admin/find-user?email=${encodeURIComponent(email)}`;
    } else {
      url = `${BaseUrl.trim()}/admin/find-user?mobileNumber=${mobileNumber}`;
    }
  }
  
  try {
    const response = await axios.get(url, getAuthHeaders());
    return response.data?.data;
  } catch (error) {
    throw error;
  }
};

export const registerPatient = async (patientData) => {
  const url = `${BaseUrl.trim()}/admin/register-patient`;
  
  try {
    const response = await axios.post(url, patientData, getAuthHeaders());
    return response.data?.data;
  } catch (error) {
    throw error;
  }
};

export const createOrder = async (formData) => {
  const url = `${BaseUrl.trim()}/admin/create-order`;
  
  try {
    const response = await axios.post(url, formData, {
      ...getAuthHeaders(),
      headers: {
        ...getAuthHeaders().headers,
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data?.data;
  } catch (error) {
    throw error;
  }
};

export const fetchOrders = async (params = {}) => {
  const { page = 1, limit = 20, status, search } = params;

  const query = new URLSearchParams();
  query.set("page", page);
  query.set("limit", limit);
  if (status) query.set("status", status);
  if (search) query.set("search", search);

  const queryString = query.toString();
  const url =
    `${BaseUrl.trim()}/admin/all-orders` +
    (queryString ? `?${queryString}` : "");

  try {
    const response = await axios.get(url, getAuthHeaders());
    return response.data?.data;
  } catch (error) {
    throw error;
  }
};

export const fetchOrderById = async (id) => {
  const url = `${BaseUrl.trim()}/admin/order/${id}`;
  const response = await axios.get(url, getAuthHeaders());
  return response.data?.data;
};

export const updateOrderStatus = async (id, status) => {
  const url = `${BaseUrl.trim()}/admin/update-status/${id}`;
  const payload = { status };

  const authConfig = getAuthHeaders();
  const response = await axios.put(url, payload, authConfig);
  return response.data?.data;
};

export const deleteOrder = async (id) => {
  const url = `${BaseUrl.trim()}/admin/delete-order/${id}`;
  const response = await axios.delete(url, getAuthHeaders());
  return response.data;
};

export const placeOrder = async (formData) => {
  const url = `${BaseUrl.trim()}/user/placeOrder`;
  const authConfig = getAuthHeaders();

  const response = await axios.post(url, formData, {
    ...authConfig,
    headers: {
      ...authConfig.headers,
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data?.data;
};
